import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
BetaReportsController.$inject = ["_", "$state", "$sce", "$location", "reportService", "tokenService", "apiUrls", "storageService", "userService"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* injects from baggage-loader */
require('./beta-reports.component.html');

import angular from 'angular';
import './reports.scss';
import './reports.css';
angular.module('AaApp.Opp').component('betaReports', {
  templateUrl: '/app/components/reports/beta-reports.component.html',
  controller: BetaReportsController
});
/* @ngInject */

function BetaReportsController(_, $state, $sce, $location, reportService, tokenService, apiUrls, storageService, userService) {
  var $ctrl = this;
  $ctrl.reportsEnabled = false;
  $ctrl.reportEnabled = true;
  $ctrl.reportId;
  $ctrl.reportName = "";
  $ctrl.viewUrl = "";
  $ctrl.reportIsFavorite = false;
  $ctrl.reportPromise;
  $ctrl.reportSpecification;
  $ctrl.tableauUrl;
  $ctrl.$onInit = init;
  $ctrl.$onChanges = onChanges;
  $ctrl.tableauToken;
  $ctrl.accountPlatformIds;

  if ($state && $state.params) {
    if ($state.params.id) {
      $ctrl.reportId = $state.params.id;
    }
  }

  function onChanges(changes) {
    if (changes) {
      getReportDetails();
    }
  }

  function init() {
    $ctrl.reportEnabled = true;
    var moduleIds = storageService.getItem('moduleIds');
    var authorizedReports = reportService.getAuthorizedReports(moduleIds);
    $ctrl.reportsEnabled = authorizedReports.length > 0;
  }

  function getReportDetails() {
    userService.getUserProfile().then(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(userProfile) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (userProfile && userProfile.accountPlatformIds && userProfile.accountPlatformIds.length > 0) {
                  $ctrl.accountPlatformIds = userProfile.accountPlatformIds.join(',');
                  $ctrl.reportingPlatformIds = $ctrl.accountPlatformIds;
                }

                reportService.getBetaReportList().then(function (results) {
                  if (results && results.Success == true && results.Data && results.Data.length > 0) {
                    var reports = results.Data;

                    var currentBetaReport = _.find(reports, {
                      Id: $ctrl.reportId
                    });

                    if (currentBetaReport) {
                      $ctrl.reportName = currentBetaReport.Name;
                      $ctrl.reportIsFavorite = currentBetaReport.IsFavorite;
                      $ctrl.viewUrl = currentBetaReport.ViewUrl;
                      setReportUrl(currentBetaReport.IsEnterpriseReport);
                    } else {
                      $ctrl.reportEnabled = false;
                    }
                  } else {
                    $ctrl.reportEnabled = false;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  function setReportUrl(isEnterpriseReport) {
    reportService.getTableauToken(isEnterpriseReport).then(function (results) {
      if (results && results.Success == true) {
        $ctrl.tableauToken = results.Data;
        var url = apiUrls.betaReportsUrl + $ctrl.viewUrl;
        $ctrl.tableauUrl = $sce.trustAsResourceUrl(url);
      }
    });
  }
}